(() => {
  const setupPasswordToggles = () => {
    document.querySelectorAll('[data-password-toggle]').forEach((toggle) => {
      if (toggle.dataset.passwordToggleReady === 'true') return;

      const input = document.querySelector(toggle.dataset.passwordTarget);
      if (!input) return;

      toggle.dataset.passwordToggleReady = 'true';
      toggle.addEventListener('click', () => {
        const isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        toggle.setAttribute('aria-label', isPassword ? 'Ocultar contraseña' : 'Mostrar contraseña');
        toggle.classList.toggle('password-toggle--visible', isPassword);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupPasswordToggles, { once: true });
  } else {
    setupPasswordToggles();
  }
})();
